import React from "react";
import { MoneyBoxIcon, MoneyIcon, ShieldIcon } from "../SVGIcons";
import SmarterBg from "../../assets/img/home-smarter.png";
import clsx from "clsx";
import AnimatedContent from "../AnimatedContent";

const SmarterItem = ({ icon, description, className }: { icon: React.ReactNode, description: string, className?: string }) => (
    <div className={`relative bg-white/1 backdrop-blur-[40px] rounded-[100px] w-fit ${className}`}>
        <div
            className="p-[24px] rounded-[100px] w-full h-full absolute top-0 left-0"
            style={{
                border: '1px solid',
                mask: 'linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
                WebkitMask: 'linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))'
            }}
        />

        <div className="p-[24px] flex gap-[10px] items-center w-fit">
            {icon}
            <div className="text-[14px] font-medium">
                {description}
            </div>
        </div>
    </div>
);

const Smarter = () => {
    return <div className="w-full border-b border-[#161616]">
        <div className={clsx(
            "flex flex-col relative py-[40px] pt-[40px] z-[3] px-[16px] w-full max-w-[1112px] mx-auto",
            "md:pt-[120px] md:flex-row"
        )}>
            <div className={clsx(
                "w-full flex justify-start mb-[20px] relative z-[2]",
                "md:w-[50%] md:justify-center md:mb-0"
            )}>
                <AnimatedContent>
                    <div className={clsx(
                        "text-start text-[42px] leading-[1.2] font-semibold tracking-[-2.48px]",
                        "md:text-[62px]"
                    )}>
                        Smarter TAO.
                        <br />
                        Smarter Upside.
                    </div>
                </AnimatedContent>
            </div>
            <div className={clsx(
                "w-full flex flex-col relative z-[2]",
                "md:w-[50%]"
            )}>
                <div className={clsx(
                    "text-white/70 text-[14px] font-normal mb-[20px]",
                    "md:mb-[24px]"
                )}>
                    Most TAO sits idle — slowly earning root yield.
                    <br />
                    Some chase alpha manually — but with limited size.
                </div>
                <div className={clsx(
                    "text-[16px] font-medium mb-[40px]",
                    "md:mb-[16px]"
                )}>
                    TaoFlow changes the equation
                </div>
                <div className="flex flex-col gap-[12px] relative">
                    <SmarterItem
                        icon={<MoneyBoxIcon fillColor="#00FFEE" className="w-[32px] h-[32px]" />}
                        description="Lend TAO to earn yield from staking and trader profits"
                    />
                    <SmarterItem
                        icon={<MoneyIcon fillColor="#00FFEE" className="w-[32px] h-[32px]" />}
                        description="Borrow up to 10× to amplify your alpha exposure"
                    />
                    <SmarterItem
                        icon={<ShieldIcon fillColor="#00FFEE" />}
                        description="All backed by collateral and real-time liquidation rails"
                    />
                </div>
            </div>
            <img src={SmarterBg} alt="Smarter" className="absolute right-0 bottom-0 aspect-[570/300] h-[70%] object-cover" />
        </div>
    </div>;
};

export default Smarter;
